import EmployManegerProyect from "../img/Employee.png";
import LibratyMJProyect from "../img/Library.png";
import MovieApp from "../img/MovieAPP.png";
import ComunidaAnime from "../img/comunidad Anime.png";

export const DataProjects = [
  {
    id: 1,
    img: EmployManegerProyect,
    linkPage: "https://manager-employee.netlify.app",
    linkCode: "https://github.com/MelvinRB27/employee",
    transition: "fade-right",
    comingSoon: false,
    tecnologies: ["React", "JavaScript", "CSS", "FireBase"],
  },
  {
    id: 2,
    img: LibratyMJProyect,
    linkPage: "https://library-mj.netlify.app/",
    linkCode: "https://github.com/MelvinRB27/online-library",
    transition: "fade-down-right",
    comingSoon: false,
    tecnologies: ["React", "Google Books", "Golang", "AOS"],
  },
  {
    id: 3,
    img: MovieApp,
    linkPage: "https://movie-preview27.netlify.app/",
    linkCode: null,
    // linkCode: "https://github.com/MelvinRB27/movie-app",
    transition: "fade-right",
    comingSoon: false,
    tecnologies: ["Vuejs", "CSS", "SCSS", "MovieDB"],
  },
  {
    id: 4,
    img: ComunidaAnime,
    linkPage: "https://animecomunity.netlify.app/",
    linkCode: null,
    transition: "fade-right",
    comingSoon: false,
    tecnologies: ["React", "Redux", "CSS", "kitsu"],
  },
];
